<template>
  <Card class="page-disease">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <el-input
          v-model="keywords"
          placeholder="请输入病种名称/编码"
          style="max-width: 350px"
          @keyup.enter.native="getQueryList"
        />
        <el-button type="primary" round style="margin-left: 30px" @click="getQueryList">搜索</el-button>
        <p style="font-size: 14px;line-height:40px;margin-left: 20px;">为了便于统计，需将病种库名称、编码、分类规范管理</p>
      </div>
      <el-button type="primary" round @click="add">新增病种</el-button>
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-button type="text" style="margin-right: 10px" @click="edit(row)">编辑</el-button>
        <!-- <el-popconfirm title="确定删除该病种吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>-->
      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{ cur.id ? "编辑病种" : "新增病种" }}</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="病种名称" prop="disease_name">
          <Input
            v-model.trim="cur.disease_name"
            :disabled="read"
            :maxlength="20"
            placeholder="请输入病种名称"
          ></Input>
        </FormItem>

        <FormItem label="病种编码" prop="disease_code">
          <Input
            v-model.trim="cur.disease_code"
            :disabled="read"
            :maxlength="10"
            placeholder="请输入病种编码"
          ></Input>
        </FormItem>
        <FormItem label="病种分类名称" prop="disease_category_name">
          <Input
            v-model.trim="cur.disease_category_name"
            :disabled="read"
            :maxlength="20"
            placeholder="请输入病种分类名称"
          ></Input>
        </FormItem>
        <FormItem label="病种分类Id" prop="disease_category_id">
          <Input
            v-model.trim="cur.disease_category_id"
            :disabled="read"
            :maxlength="10"
            placeholder="请输入病种分类Id"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button v-if="!read" type="info" round @click="cancel">取消</el-button>
        <el-button v-if="!read" type="primary" round :loading="modalLoading" @click="save">保存</el-button>
      </div>
    </Modal>
  </Card>
</template>
<script>
import {
  getDiseaseListApi,
  updateDiseaseApi,
  deleteDiseaseApi,
  addDiseaseApi,
  getDeptListApi,
  getDiseaseBaseListApi,
} from '../../api/diseaseList'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      keywords: '',
      columns: [
        {
          title: '病种名称',
          align: 'center',
          key: 'disease_name',
        },
        {
          title: '病种编码',
          align: 'center',
          key: 'disease_code',
        },

        {
          title: '病种分类名称',
          align: 'center',
          key: 'disease_category_name',
        },
        {
          title: '病种分类ID',
          align: 'center',
          key: 'disease_category_id',
        },

        {
          title: '操作',
          align: 'center',
          slot: 'action',
        },
      ],
      dataSource: [],
      cur: {
        disease_name: '',
        disease_code: '',
        disease_category_name: '',
        disease_category_id: '',
      },
      rule: {
        disease_name: [
          {
            required: true,
            message: '请填写病种名称',
            trigger: 'blur',
          },
        ],
        disease_code: [
          {
            required: true,
            message: '请填写病种编码',
            trigger: 'blur',
          },
        ],
        disease_category_name: [
          {
            required: true,
            message: '请填写病种分类名称',
            trigger: 'blur',
          },
        ],
        disease_category_id: [
          {
            required: true,
            message: '请输入病种分类Id',
            trigger: 'blur',
          },
        ],
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      dept: [],
      diseaseBaseList: [],
    }
  },
  computed: {
    ...mapGetters(['shift']),
  },
  created() {
    this.getList()
  },
  methods: {
    onCurrentChange(current) {
      this.page = current
      this.getList()
    },
    onSizeChange(size) {
      this.size = size
      this.getList()
    },
    getQueryList() {
      this.page = 1
      this.getList()
    },
    handleDisease(item) {
      if (item) {
        this.cur.name = item.label
        this.cur.code = item.value
      } else {
        this.cur.name = ''
        this.cur.code = ''
      }
    },
    getList() {
      this.loading = true
      const { page, size, keywords } = this
      getDiseaseListApi({ page, size, keywords })
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data
            this.total = res['x-total-count'] || res.data.length
            if (this.total && !this.dataSource.length && this.page > 1) {
              this.page = this.page - 1
              this.getList()
            }
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => (this.loading = false))
    },
    showModal() {
      this.show = true
    },
    add() {
      this.cur = {
        disease_name: '',
        disease_code: '',
        disease_category_name: '',
        disease_category_id: '',
      }
      this.showModal()
    },
    edit(row) {
      this.cur = JSON.parse(JSON.stringify(row))
      this.showModal()
    },
    remove(row) {
      console.log(row, row.id)
      deleteDiseaseApi(row.id).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除成功')
          this.getList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    cancel() {
      this.$refs.form.resetFields()
      this.show = false
      this.modalLoading = false
    },
    save() {
      console.log(this.cur)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          if (this.cur.id) {
            updateDiseaseApi(this.cur).then((res) => {
              this.modalLoading = false
              if (res.code === 0) {
                this.cancel()
                this.getList()
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            addDiseaseApi(this.cur).then((res) => {
              this.modalLoading = false
              if (res.code === 0) {
                this.cancel()
                this.getList()
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    },
  },
}
</script>
<style lang="less">
.page-disease {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
